import axios from '../axiosConfig'; // Adjust the import path accordingly
import User from "./User";

//const express_server_url = process.env.REACT_APP_SERVER_URL;
const express_server_url = window.SERVER_CONFIG.REACT_APP_SERVER_URL;
const dotnet_server_url = window.SERVER_CONFIG.REACT_APP_DOTNETSERVER_URL;

var WebApiUrl = express_server_url;
WebApiUrl = express_server_url.replace("localhost", window.location.hostname);

const DynamicShortcutButton = {

    insertDynamicShortcutButton: async (data) => {
        console.log(data)
        
        try {
            const apiUrl = `${WebApiUrl}/api/DynamicShortcutButton/create`;
            console.log(apiUrl);
            const response = await axios.post(apiUrl, {
                name: data.name,
                formId: Number(data.formId),
                description: data.description
            }, {
                withCredentials: true,
                credentials: 'include',
            });

            console.log("Response:", response.data);
            return true;
        } catch (error) {
               console.error('Error:', error.message);
            if (error.message == "Request failed with status code 401" || error.message == "Access denied. Token not provided" || error.message == "Request failed with status code 403") {
                localStorage.removeItem('loginAccountUserData');
                localStorage.removeItem("loginUser");
                localStorage.clear();
                await User.Logout();
                window.location.href = "/loginpanel";
            }

            if (error.response && error.response.status === 401) {
                alert("Failed");
            } else {
                alert("An error occurred. Please try again.");
            }
        }
    },

    // ************************* Get All ***************************

    getDynamicShortcutButton: async () => {
        try {
            const apiUrl = `${WebApiUrl}/api/DynamicShortcutButton/GetDynamicShortcutButtons`;
            //const apiUrl = `${express_server_url}/api/Station/GetStationMasters`;
            const response = await axios.post(apiUrl, {}, {
                withCredentials: true,
            });
            console.log('Response:', response.data.result);
            return response.data.result;

        } catch (error) {
             console.error('Error:', error.message);
            if (error.message == "Request failed with status code 401" || error.message == "Access denied. Token not provided" || error.message == "Request failed with status code 403") {
                localStorage.removeItem('loginAccountUserData');
                localStorage.removeItem("loginUser");
                localStorage.clear();
                await User.Logout();
                window.location.href = "/loginpanel";
            }
        }
    },


    // ************************* Delete ****************************
    deleteDynamicShortcutButton: async (formId) => {
        try {
            const apiUrl = `${WebApiUrl}/api/DynamicShortcutButton?formId=${formId}`;
            const response = await axios.delete(apiUrl, {
                withCredentials: true,
            });
            console.log('Delete Response:', response.data.result);
            return true;
        } catch (error) {
             console.error('Error:', error.message);
            if (error.message == "Request failed with status code 401" || error.message == "Access denied. Token not provided" || error.message == "Request failed with status code 403") {
                localStorage.removeItem('loginAccountUserData');
                localStorage.removeItem("loginUser");
                localStorage.clear();
                await User.Logout();
                window.location.href = "/loginpanel";
            }
        }
    },

    // ************************* Get By Id ****************************
    getDynamicShortcutButtonById: async (id) => {
        try {
            const apiUrl = `${WebApiUrl}/api/DynamicShortcutButton?formId=${id}`;
            const response = await axios.get(apiUrl, {}, {
                withCredentials: true,
            });
            console.log('Response:', response.data.result);
            return response.data.result;
        } catch (error) {
             console.error('Error:', error.message);
            if (error.message == "Request failed with status code 401" || error.message == "Access denied. Token not provided" || error.message == "Request failed with status code 403") {
                localStorage.removeItem('loginAccountUserData');
                localStorage.removeItem("loginUser");
                localStorage.clear();
                await User.Logout();
                window.location.href = "/loginpanel";
            }
        }
    },
    // *************************** Update ***************************
    updateDynamicShortcutButton: async (data, id) => {
        console.log(data)

        try {
            const apiUrl = `${WebApiUrl}/api/DynamicShortcutButton?formId=${data.id}`;
            console.log(apiUrl);
            const response = await axios.put(apiUrl, {
                id: Number(data.id),
                name: data.name,
                formId: Number(data.formId),
                description: data.description
            }, {
                withCredentials: true,
                credentials: 'include',
            });

            console.log("Response:", response.data);
            return response.data.isSuccess;
        } catch (error) {
               console.error('Error:', error.message);
            if (error.message == "Request failed with status code 401" || error.message == "Access denied. Token not provided" || error.message == "Request failed with status code 403") {
                localStorage.removeItem('loginAccountUserData');
                localStorage.removeItem("loginUser");
                localStorage.clear();
                await User.Logout();
                window.location.href = "/loginpanel";
            }
            if (error.response && error.response.status === 401) {
                alert("Failed");
            } else {
                alert("An error occurred. Please try again.");
            }
        }
    },

    // ************************* Get filtered User Credential ***************************
    getFilteredDynamicShortcutButton: async (filterData) => {
        const filteredData = filterData.map(data => ({
            fieldName: data.fieldName,
            operatorName: data.operatorName,
            compareValue: data.compareValue
        }));
        try {
            const apiUrl = `${WebApiUrl}/api/DynamicShortcutButton/GetDynamicShortcutButtons`;
            const response = await axios.post(apiUrl, {
                filter: filteredData,
                order: [
                    {
                        propertyName: "string",
                        ascending: true
                    }
                ],
                pageNumber: 0,
                pageSize: 0
            }, {
                withCredentials: true,
            });
            console.log('Response:', response.data.result);
            return response.data.result;

        } catch (error) {
             console.error('Error:', error.message);
            if (error.message == "Request failed with status code 401" || error.message == "Access denied. Token not provided" || error.message == "Request failed with status code 403") {
                localStorage.removeItem('loginAccountUserData');
                localStorage.removeItem("loginUser");
                localStorage.clear();
                await User.Logout();
                window.location.href = "/loginpanel";
            }
        }
    },
};

export default DynamicShortcutButton;
